import React from 'react';
import { Box } from '@mui/material';
import { Theme } from '@routific/hive';
import Checkbox from '../../../shared/Checkbox';
import { ExportColumn } from './types';

interface Props {
  columns: ExportColumn[];
  selectedKeys: Set<string>;
  onToggle: (key: string) => void;
}

const ColumnGrid: React.FC<Props> = ({ columns, selectedKeys, onToggle }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      columnGap: Theme.Spacing.mdSpacing,
      rowGap: Theme.Spacing.xsSpacing,
    }}
  >
    {columns.map((column) => (
      <Checkbox
        key={column.key}
        checked={selectedKeys.has(column.key)}
        onChange={() => onToggle(column.key)}
        label={
          <Box component="span" title={column.label} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {column.label}
          </Box>
        }
        data-cy={`export-column-${column.key}`}
        sx={{
          minWidth: 0,
          '& .MuiFormControlLabel-root': {
            minWidth: 0,
            maxWidth: '100%',
            marginLeft: `-${Theme.Spacing.smSpacing}`,
            marginRight: 0,
          },
          '& .MuiFormControlLabel-label': { minWidth: 0, overflow: 'hidden' },
        }}
      />
    ))}
  </Box>
);

export default ColumnGrid;
